import {normalizeSellerProfile, SellerProfilePayload} from "./seller_profile_types";

const PROFILE_URL = "/api/seller-profile";

const jsonHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json"
};

async function parseJson(response: Response) {
    return response.json().catch(() => null);
}

export async function fetchSellerProfile(): Promise<SellerProfilePayload | null> {
    const response = await fetch(PROFILE_URL, {
        method: "GET",
        credentials: "same-origin",
        headers: {Accept: "application/json"}
    });

    if (response.status === 404) {
        const err: any = new Error("Seller profile endpoint not found");
        err.status = 404;
        throw err;
    }

    if (!response.ok) {
        const err: any = new Error("Failed to load seller profile");
        err.status = response.status;
        throw err;
    }

    const data = await parseJson(response);
    // Accept either raw profile or { data: profile }
    const profile = data?.data && typeof data.data === "object" ? data.data : data;
    return normalizeSellerProfile(profile);
}

export async function saveSellerProfile(payload: SellerProfilePayload): Promise<SellerProfilePayload> {
    const body = {
        display_name: payload.display_name.trim(),
        phone: payload.phone.trim(),
        email_public: payload.email_public.trim(),
        description: payload.description.trim(),
        address_street: payload.address_street.trim(),
        address_city: payload.address_city.trim(),
        address_voivodeship: payload.address_voivodeship.trim(),
        address_postal: payload.address_postal.trim(),
        logo_url: payload.logo_url,
        logo_key: payload.logo_key,
        cover_url: payload.cover_url,
        cover_key: payload.cover_key
    };

    const response = await fetch(PROFILE_URL, {
        method: "POST",
        credentials: "same-origin",
        headers: jsonHeaders,
        body: JSON.stringify(body)
    });

    if (!response.ok) {
        const err: any = new Error("Failed to save seller profile");
        err.status = response.status;
        err.body = await parseJson(response);
        throw err;
    }

    const data = await parseJson(response);
    const profile = data?.data && typeof data.data === "object" ? data.data : data;
    return normalizeSellerProfile(profile || body);
}
